import React from 'react';

import { ReactComponent } from './dam.svg';

function FarmbotDamIcon() {
  return <ReactComponent width={18} />;
}

export default FarmbotDamIcon;
